import React, { useEffect, useState } from "react";
import { Form, Input, Select, Button, Space } from "antd";

const { Option } = Select;
const { TextArea } = Input;

const ChannelForm = ({ initialValues, onSubmit, onCancel }) => {
  const [form] = Form.useForm();
  const [channelType, setChannelType] = useState("feishu");

  useEffect(() => {
    if (initialValues) {
      form.setFieldsValue({
        ...initialValues,
        config: initialValues.config || "",
      });
      setChannelType(initialValues.type);
    } else {
      form.resetFields();
      setChannelType("feishu");
    }
  }, [initialValues, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      onSubmit(values);
    } catch (err) {
      console.error("表单验证失败:", err);
    }
  };

  const getConfigPlaceholder = () => {
    switch (channelType) {
      case "feishu":
        return '{"webhook_url": "https://open.feishu.cn/open-apis/bot/v2/hook/xxx"}';
      case "email":
        return '{"smtp_host": "smtp.example.com", "smtp_port": 587, "username": "user@example.com", "password": "xxx", "from": "noreply@example.com", "to": ["admin@example.com"]}';
      case "webhook":
        return '{"url": "https://example.com/webhook", "method": "POST", "headers": {"Authorization": "Bearer xxx"}}';
      default:
        return "{}";
    }
  };

  return (
    <Form form={form} layout="vertical">
      <Form.Item
        label="渠道名称"
        name="name"
        rules={[{ required: true, message: "请输入渠道名称" }]}
      >
        <Input placeholder="请输入渠道名称" />
      </Form.Item>

      <Form.Item
        label="渠道类型"
        name="type"
        rules={[{ required: true, message: "请选择渠道类型" }]}
      >
        <Select
          placeholder="请选择渠道类型"
          onChange={(value) => setChannelType(value)}
          disabled={!!initialValues}
        >
          <Option value="feishu">飞书</Option>
          <Option value="email">邮件</Option>
          <Option value="webhook">Webhook</Option>
        </Select>
      </Form.Item>

      <Form.Item
        label="配置信息"
        name="config"
        rules={[{ required: true, message: "请输入配置信息" }]}
        extra="JSON 格式的配置信息"
      >
        <TextArea
          rows={6}
          placeholder={getConfigPlaceholder()}
        />
      </Form.Item>

      <Form.Item>
        <Space>
          <Button type="primary" onClick={handleSubmit}>
            提交
          </Button>
          <Button onClick={onCancel}>取消</Button>
        </Space>
      </Form.Item>
    </Form>
  );
};

export default ChannelForm;
